import { NotificationManager } from 'react-notifications';
import axios from 'axios';

import { IMerchantAccount } from '../accountsPayment/types';

export const fetchPayoutMerchantAccountsRequest = async (): Promise<IMerchantAccount[] | []> => {
  try {
    const res = await axios.get(`api/v1/payout/merchant-accounts`);
    return res.data;
  } catch (error) {
    NotificationManager.error(`Can't fetch accounts`);
    return [];
  }
};

export const fetchMerchantAccountPayoutByIdRequest = async (id: string): Promise<IMerchantAccount | null> => {
  try {
    const res = await axios.get(`api/v1/payout/merchant-accounts/${id}`);
    return res.data;
  } catch (error) {
    NotificationManager.error(`Can't fetch account ${id}`);
    return null;
  }
};

export const updateProvidersMerchantPayoutRequest = async (vals: Partial<IMerchantAccount>): Promise<IMerchantAccount | null> => {
  try {
    const data = { ...vals };
    delete data.id;
    delete data.identity;
    const res = await axios.post(`/api/v1/payout/merchant-accounts/${vals.id}/settings`, data);
    return res.data;
  } catch (error) {
    NotificationManager.error(`Can't update provider`);
    return null;
  }
};
